import React, { Component } from 'react';
import filter from 'lodash/filter';
import './Surveys.css';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Header from '../../components/Header';
import surveyTable from '../../tables/surveys';
import surveyActions from '../../actions/survey';
import Table from '../../components/Table';
import Modal from '../../components/Modal';
import formHelpers from '../../helpers/FormHelpers';
import Guide from '../../components/Guide';
import Step from '../../components/Step';
import { validatePhases, checkForErrors } from '../../helpers/Validation';
import { extractPhasesOrFail } from '../../helpers/ValueBuilder';
import editPhase1Fields from '../../forms/survey/editPhase1';
import phase1Fields from '../../forms/survey/createPhase1';
import phase2Fields from '../../forms/survey/createPhase2';
import phase3Fields from '../../forms/campaign/createSurveyPhase3';
import phase4Fields from '../../forms/survey/createPhase3';
import modalActions from '../../actions/modal';
import populateForm from '../../helpers/PopulateForm';
import SurveyInfo from '../../helpers/SurveyInfo';
import Button from '../../components/Button';
import surveyHelpers from '../../helpers/survey/buildValues';
import promotionHelpers from '../../helpers/promotions/buildValues';
import editPhase1 from '../../forms/survey/editPhase1';


class Surveys extends Component {
	constructor() {
		super();
		this.handleModalToggle = this.handleModalToggle.bind(this);
		this.handleAddNewQuestionClick = this.handleAddNewQuestionClick.bind(this);
    this.handleNewClick = this.handleNewClick.bind(this);
    this.handleNextClick = this.handleNextClick.bind(this);
    this.handleFieldChange = this.handleFieldChange.bind(this);
    this.handleSelectFieldChange = this.handleSelectFieldChange.bind(this);
    this.handleFieldBlur = this.handleFieldBlur.bind(this);
    this.performCreateOrUpdate = this.performCreateOrUpdate.bind(this);
    this.handleSelectClick = this.handleSelectClick.bind(this);
    this.handleFieldFocus = this.handleFieldFocus.bind(this);
    this.handleCheckboxClick = this.handleCheckboxClick.bind(this);
    this.handleMultiSelectClick = this.handleMultiSelectClick.bind(this);
    this.handleModalCloseClick = this.handleModalCloseClick.bind(this);
		this.handleEditClick = this.handleEditClick.bind(this);
		this.handlePhaseChange = this.handlePhaseChange.bind(this);
		this.resetFormAfterRequest = this.resetFormAfterRequest.bind(this);
	}

  componentWillMount() {
    const { dispatch, vendor, location } = this.props;
    if (vendor.selected && vendor.selected.apikey &&
      location.selected && location.selected.apikey) {
      dispatch(surveyActions.list(vendor.selected.apikey, location.selected.apikey));
    }

    this.setState({
      activeSection: '1',
      currentPhase: 'phase1Fields',
      buttonText: 'Next',
      editPhase1Fields,
      phase1Fields,
      phase2Fields: surveyHelpers.addLocationsToMulti(phase2Fields, location.data),
      phase3Fields,
      phase4Fields,
      updateField: false,
      modalInfo: SurveyInfo,
    });
  }

	resetFormAfterRequest() {
		const { location } = this.props;
    this.setState({
      updateField: false,
      editPhase1Fields,
      phase1Fields,
      phase2Fields: surveyHelpers.addLocationsToMulti(phase2Fields, location.data),
      phase3Fields,
      phase4Fields,
      activeSection: '1',
      currentPhase: 'phase1Fields',
      buttonText: 'Next',
      editActive: false,
    });
	}

  performCreateOrUpdate(currentPhase) {
    const {
			nextSection, phase1Fields, editActive, surveyApikey,
			phase2Fields, phase3Fields, phase4Fields, updateField, editPhase1Fields
		} = this.state;

		const { dispatch, vendor, location } = this.props;
		let promotionData = extractPhasesOrFail({ phase3Fields });
		let surveyData = extractPhasesOrFail({ phase1Fields, phase2Fields, phase4Fields });
		let editData = extractPhasesOrFail({ editPhase1Fields });
		let locationApikey = location.selected.apikey;
		let surveyDataPrep = {};

		if (editData) {
			surveyDataPrep = surveyHelpers.prepForPush(editData);
		} else {
			surveyDataPrep = surveyHelpers.prepForPush(surveyData);
		}
		if (!editData && surveyDataPrep.survey_type === 'location') {
			locationApikey = surveyDataPrep.location_apikeys[0];
    }
    if (surveyData && updateField) {
    	dispatch(surveyActions.update(
				surveyDataPrep,
				promotionHelpers.prepClaimForPush(promotionData),
				vendor.selected.apikey,
				locationApikey
			));
			this.resetFormAfterRequest();
		} else if (surveyData) {
    	dispatch(surveyActions.create(
				surveyDataPrep,
				promotionHelpers.prepClaimForPush(promotionData),
				vendor.selected.apikey,
				locationApikey
			));
			// this.resetFormAfterRequest();
    } else if (editActive && editData) {
			editData.promotion_apikey = this.state.updateField.promotion_apikey;
			dispatch(surveyActions.update(
				surveyDataPrep,
				{},
				vendor.selected.apikey,
				locationApikey,
				surveyApikey
			));
			this.resetFormAfterRequest();
			this.props.dispatch(modalActions.modalToggle(false));
    } else {
    	this.handlePhaseChange(buttonNext, nextSection, nextPhase);
    }
  }

	handleNextClick() {
		const { currentPhase, phase1Fields, activeSection, editActive } = this.state;
		let buttonNext = 'Next';
    let nextSection = (parseInt(activeSection, 10) + 1).toString();
    let nextPhase = 'phase' + nextSection + 'Fields';
    if (nextSection === '6' || editActive === true) this.performCreateOrUpdate(currentPhase);
    else this.handlePhaseChange(buttonNext, nextSection, nextPhase);
  }

	handleBackClick = () => {
		const { currentPhase, phase1Fields, activeSection, editActive } = this.state;
		let buttonNext = 'Next';
    let nextSection = (parseInt(activeSection, 10) - 1).toString();
    let nextPhase = 'phase' + nextSection + 'Fields';
    if (nextSection === '0') {
			return false;
		} else {
			this.handlePhaseChange(buttonNext, nextSection, nextPhase, true);
		}
  }

	handlePhaseChange(bNext, nSection, nPhase, back=false) {
    const { phase1Fields, currentPhase } = this.state;
    new Promise((resolve, reject) => {
			if (currentPhase !== 'phase5Fields') {
				this.setState({
					[currentPhase]: formHelpers.blurphase(this.state[currentPhase])
				})
			}
      resolve();
    }).then(() => {
      if (currentPhase === 'phase5Fields' || checkForErrors(this.state[currentPhase]) === false) {
        if (nSection === '5') bNext = 'Finish';
				else if (nSection === '3' && phase1Fields.promotion_type.value !== 'offer') {
					nPhase = 'phase4Fields';
					nSection = back ? '2' : '4';
					bNext = 'Next';
				}
        this.setState({
					activeSection: nSection,
          buttonText: bNext,
          currentPhase: nPhase
        })
      } else {
        this.setState({
          [currentPhase]: validatePhases(this.state[currentPhase])
        })
      }
    })
	}

  handleSelectFieldChange(option, name, position=null, parentName=null) {
		new Promise((resolve, reject) => {
			if (name === 'promotion_type') {
				let isHidden = option.value !== 'points';
				this.setState({
					phase1Fields: {
						...this.state.phase1Fields,
						points: {
							...this.state.phase1Fields.points,
							hidden: isHidden,
							isRequired: !isHidden
						}
					}
				})
			}
			resolve();
		}).then(() => {
	    if (position !== null)
	      formHelpers.handleSelectArrayFieldChange(option, name, this.state.currentPhase, parentName, position, this);
	    else
	    	formHelpers.handleSelectFieldChange(option, name, this.state.currentPhase, this);
		})
	}

	handleMultiSelectClick(name, index, value) {
		let single = this.state.phase1Fields.promotion_type.value === 'points' ? true : false;
		formHelpers.handleMultiSelectClick(name, index, value, this.state.currentPhase, this, single);
	}

  handleCheckboxClick(name, value) {
    formHelpers.handleCheckboxClick(value, name, this.state.currentPhase, this);
  }

  handleFieldBlur(name, position=null, parentName=null) {
    if (position !== null)
      formHelpers.handleArrayFieldBlur(name, this.state.currentPhase, parentName, position, this);
    else
    	formHelpers.handleFieldBlur(name, this.state.currentPhase, this);
  }

  handleSelectClick(field, position=null, parentName=null) {
		if (position !== null)
			formHelpers.handleArraySelectClick(field, this.state.currentPhase, parentName, position, this);
		else
			formHelpers.handleSelectClick(field, this.state.currentPhase, this);
  }

  handleFieldChange(value, name, position=null, parentName=null) {
    if (position !== null)
      formHelpers.handleArrayFieldChange(value, name, this.state.currentPhase, parentName, position, this);
    else
    	formHelpers.handleFieldChange(value, name, this.state.currentPhase, this);
  }

  handleFieldFocus(name, position=null, parentName=null) {
    if (position !== null)
      formHelpers.handleArrayFieldFocus(name, this.state.currentPhase, parentName, position, this);
    else
      formHelpers.handleFieldFocus(name, this.state.currentPhase, this);
  }

	handleModalToggle() {
    const { dispatch, modal } = this.props;
    dispatch(modalActions.modalToggle(!modal.showModal));
	}

	handleModalCloseClick() {
		this.setState({
      activeSection: '1',
      currentPhase: 'phase1Fields',
      buttonText: 'next'
		})
		this.handleModalToggle();
	}

  handleNewClick() {
		const { location } = this.props;
		this.resetFormAfterRequest();
    this.setState({
      phase1Fields: JSON.parse(JSON.stringify(phase1Fields)),
      phase2Fields: surveyHelpers.addLocationsToMulti(phase2Fields, location.data),
      phase3Fields: JSON.parse(JSON.stringify(phase3Fields)),
      phase4Fields: JSON.parse(JSON.stringify(phase4Fields)),
    });
    this.handleModalToggle();
  }

	handleEditClick(survey) {
		const { dispatch, vendor, location } = this.props;
		this.setState({ editActive: true, buttonText: 'Save', currentPhase: 'editPhase1Fields', surveyApikey: survey.apikey });
		this.props.dispatch(modalActions.modalToggle(true));

    this.setState({
      updateField: survey,
      editPhase1Fields: populateForm(survey, editPhase1Fields)
    })
	}

	handleAddNewQuestionClick() {
		this.setState({
			phase4Fields: {
				...this.state.phase4Fields,
				question_list: {
					...this.state.phase4Fields.question_list,
					values: [
						...this.state.phase4Fields.question_list.values,
						JSON.parse(JSON.stringify(this.state.phase4Fields.question_list.original))
					]
				}
			}
		})
	}

  render() {
		const { activeSection, modalInfo, phase1Fields, phase3Fields, phase4Fields, editPhase1Fields } = this.state;
		let formClass = 'signup__form survey__form-wrapper';
		if (activeSection >= '4') formClass = 'signup__form signup__form--full';
    return (
      <div>
				<Header
					handlePrimaryClick={this.handleNewClick}
          primaryText="NEW SURVEY"
          handleLogout={this.props.handleLogoutClick}
          title="SURVEYS" />
				<Table
					rows={this.props.survey.data}
					handleEditClick={this.handleEditClick}
					columns={surveyTable} />
					{
						this.props.modal.showModal &&
						<Modal
							handleCloseClick={this.handleModalCloseClick}
							title={modalInfo[parseInt(activeSection) - 1].title}>
							{
								parseInt(activeSection) < 4 &&
								<div className="signup__guide">
									<Guide
										header={modalInfo[parseInt(activeSection) - 1].subTitle}
										message={modalInfo[parseInt(activeSection) - 1].content}
										/>
								</div>
							}
							<div className={formClass}>
								<div className="survey__form">
									{
										parseInt(activeSection) <= '3' && this.state.editActive === false &&
										<div className="full-wrap">
											<div className="step__wrap">
												<Step text="1" isActive={activeSection === '1' ? true : false} />
												<Step text="2" isActive={activeSection === '2' ? true : false} />
												<Step text="3" isActive={activeSection === '3' ? true : false} />
											</div>
										</div>
									}
									{
										activeSection === '1' && this.state.editActive &&
										<div>
											{ formHelpers.buildFields(editPhase1Fields, this) }
										</div>
									}
									{
										activeSection === '1' && !this.state.editActive &&
										<div>
											{ formHelpers.buildFields(phase1Fields, this) }
										</div>
									}
									{
										activeSection === '2' &&
										<div>
											{ formHelpers.buildFields(this.state.phase2Fields, this) }
										</div>
									}
									{
										activeSection === '3' &&
										<div>
											{ formHelpers.buildFields(this.state.phase3Fields, this) }
										</div>
									}
									{
										activeSection === '4' &&
										<div>
											<div className="survey__header-info">
												<p className="survey__header-text">Add survey questions. Click the plus on the left to add a new question.</p>
												<p className="survey__header-text">Type the question you'd like ask, if the question already exists select it, otherwise finish typing and hit enter.</p>
												<p className="survey__header-text">Finally select the answer type.</p>
												<p className="survey__header-text">For additional quesitons repeat this process.</p>
											</div>
											{ formHelpers.buildFields(this.state.phase4Fields, this) }
											<p className="survey__button--add" onClick={this.handleAddNewQuestionClick}>Add Question</p>
											<div className="clear"></div>
										</div>
									}
									{
										activeSection === '5' &&
										<div>
											<div className="survey__header-info">
												<p className="survey__header-text">Please confirm the details of this survey</p>
											</div>
											<div className="survey__confirmation">
												<div className="survey__column-half">
													<p className="survey__label">Text Message</p>
													<div className="survey__message">
														<p className="survey__message-text">{phase1Fields.text_for_text.value}</p>
													</div>
													<p className="survey__label survey__label--wide">{phase1Fields.text_for_text.value.length} Characters = <span className="survey__blue">1 Message per customer</span></p>
												</div>
												<div className="survey__column-half">
													<div>
														<p className="survey__label">Offer Name:</p>
														<p className="survey__value">{phase3Fields.name.value ? phase3Fields.name.value : 'None'}</p>
													</div>
													<div>
														<p className="survey__label">Coins:</p>
														<p className="survey__value">{phase1Fields.points.value ? phase1Fields.points.value : 'None'}</p>
													</div>
													<div>
														<p className="survey__label">Frequency:</p>
														<p className="survey__value">{phase1Fields.frequency.value} {phase1Fields.frequency.value === 1 ? 'Visit' : 'Visits'} Between</p>
													</div>
													<div>
														<p className="survey__label">Days Between:</p>
														<p className="survey__value">{phase1Fields.re_eligible.value} {phase1Fields.re_eligible.value === 1 ? 'Day' : 'Days'} Between</p>
													</div>
													<div>
														<p className="survey__label">Max Send:</p>
														<p className="survey__value">Send Maximum {phase1Fields.max_send.value} {phase1Fields.max_send.value === 1 ? 'Time' : 'Times'}</p>
													</div>
													{(phase3Fields.days_till_expire.value > 0) &&
														<div>
															<p className="survey__label">Expiration Days:</p>
															<p className="survey__value">{phase3Fields.days_till_expire.value} Days After</p>
														</div>
													}
												</div>
												<div className="clear"></div>
											</div>
											{(phase4Fields.question_list.values.length > 1 || phase4Fields.question_list.values[0].q_type.value !== '') &&
												<div className="survey__questions">
													{phase4Fields.question_list.values.map((question, i) =>
														<div key={`surveyQuestion-${i}`} className="survey__questions-row">
															<div className="survey__questions-row-item">
																<p className="survey__label survey__label--small">Question Type:</p>
																<p className="survey__value survey__value--wide">{filter(question.q_type.options, {value: question.q_type.value})[0].name}</p>
															</div>
															<div className="survey__questions-row-item">
																<p className="survey__label survey__label--small">Question {i + 1}:</p>
																<p className="survey__value survey__value--wide">{question.q_text.value}</p>
															</div>
														</div>
													)}
												</div>
											}
											{(phase4Fields.question_list.values[0].q_type.value == '') &&
												<div className="survey__questions">
													<p className="survey__value">Please click the "Back" button below and create some questions.</p>
													<div className="clear"></div>
												</div>
											}
										</div>
									}
								</div>
								<div>
									{this.state.activeSection !== '1' &&
										<div className="survey__button-wrap">
											<Button
												allowHover={true}
												text='Back'
												onClick={this.handleBackClick}/>
										</div>
									}
									<Button
										allowHover={true}
										success={true}
										text={this.state.buttonText}
										onClick={this.handleNextClick}/>
								</div>
							</div>
						</Modal>
					}
					<h3 className="survey__footer-text">***Currently Survey Responses are under Business Intelligence***</h3>
      </div>
    );
  }
}

export default withRouter(connect(
  (state) => ({
    vendor: state.vendor,
    location: state.location,
    survey: state.survey,
    modal: state.modal
  })
)(Surveys));



/** WEBPACK FOOTER **
 ** ./src/containers/Surveys/index.js
 **/